import { Fragment } from 'react';
import { addTrailingSlash, excludeNullUndefined } from '@utils';
import { BreadcrumbList } from 'schema-dts';
import { JsonLdBase } from '@components';
import { baseBaseUrl } from '@constants';

export type BreadcrumbsData = (
  | {
      text?: string | null;
      shortText?: string | null;
      url?: string | null;
    }
  | undefined
  | null
)[];

const structuredData = (data?: BreadcrumbsData): BreadcrumbList | null =>
  data
    ? {
        '@type': 'BreadcrumbList',
        itemListElement: data.filter(excludeNullUndefined).map((e, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: e.text || '',
          item: e.url ? `${baseBaseUrl}${e.url}` : undefined,
        })),
      }
    : null;

const LinkIfExists: React.FC<{ href?: string | null }> = ({ href, children }) =>
  href ? (
    <a
      href={addTrailingSlash(href)}
      className='text-primary hover:text-top-primary'
    >
      {children}
    </a>
  ) : (
    <>{children}</>
  );

export const Breadcrumbs: React.FC<{ data?: BreadcrumbsData }> = ({ data }) => (
  <>
    <JsonLdBase data={structuredData(data)} />
    <div className='line-clamp-1'>
      {data?.map((b, i) => (
        <Fragment key={b?.url || b?.text}>
          {b && (
            <>
              {i > 0 && <span className='mx-2'>{'>'}</span>}
              <span>
                <LinkIfExists href={b.url}>
                  {b.shortText ? (
                    <>
                      <span className='lg:hidden'>{b.shortText}</span>
                      <span className='hidden lg:inline-block'>{b.text}</span>
                    </>
                  ) : (
                    b.text
                  )}
                </LinkIfExists>
              </span>
            </>
          )}
        </Fragment>
      ))}
    </div>
  </>
);
